function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import TextInput from '@adsk/alloy-react-text-input';
import { LinkButton } from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import SelectBox from '@adsk/alloy-select-box';
import iso3166 from 'iso-3166-2';
import { flexStyle, spacedStyle, linkButtonStyle } from './styles';
import AutocompleteAddress from '../AutocompleteAddress';
var ADDRESS_INPUT_MODES = {
  AUTOCOMPLETE: 'autocomplete',
  MANUAL: 'manual'
};
var AutocompleteOrManualAddress = function AutocompleteOrManualAddress(_ref) {
  var address = _ref.address,
    autocompletedAddress = _ref.autocompletedAddress,
    autocompleteAddressPlaceholder = _ref.autocompleteAddressPlaceholder,
    defaultCountry = _ref.defaultCountry,
    disabled = _ref.disabled,
    inputMode = _ref.inputMode,
    isInModal = _ref.isInModal,
    isMapboxTokenActive = _ref.isMapboxTokenActive,
    mapBoxAccessToken = _ref.mapBoxAccessToken,
    onAddressChange = _ref.onAddressChange,
    onAutocompletedAddressResult = _ref.onAutocompletedAddressResult,
    onInputModeChange = _ref.onInputModeChange,
    setMapboxTokenActive = _ref.setMapboxTokenActive,
    showManualCountry = _ref.showManualCountry,
    resetAddressOnDelete = _ref.resetAddressOnDelete;
  var _useLocale = useLocale(function (_ref2) {
      var locale = _ref2.locale;
      return require("./i18n/".concat(locale, ".json"));
    }),
    T = _useLocale.T;
  var addressLine1 = address.addressLine1,
    addressLine2 = address.addressLine2,
    city = address.city,
    stateOrProvince = address.stateOrProvince,
    postalCode = address.postalCode,
    country = address.country;
  var linkText = inputMode === ADDRESS_INPUT_MODES.MANUAL ? T.translate('ADDRESS_AUTOCOMPLETE') : T.translate('ADDRESS_MANUAL');
  var countries = useMemo(function () {
    return Object.entries(iso3166.data).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];
      return {
        isoCode: key,
        name: value.name
      };
    }).sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
  }, []);
  var regions = useMemo(function () {
    var _iso3166$data$country;
    if (country === '' || country === null || !((_iso3166$data$country = iso3166.data[country]) !== null && _iso3166$data$country !== void 0 && _iso3166$data$country.sub)) return [];
    return Object.entries(iso3166.data[country].sub).map(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];
      return {
        isoCode: key.split('-')[1],
        name: value.name
      };
    }).sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
  }, [country]);
  var countryValue = useMemo(function () {
    return country !== '' && country !== null ? {
      isoCode: country
    } : null;
  }, [country]);
  var stateOrProvinceValue = useMemo(function () {
    return stateOrProvince !== '' && stateOrProvince != null ? {
      isoCode: stateOrProvince
    } : null;
  }, [stateOrProvince]);
  var handleActivateMapboxToken = function handleActivateMapboxToken() {
    if (isMapboxTokenActive) return;
    setMapboxTokenActive(true);
    onInputModeChange(ADDRESS_INPUT_MODES.AUTOCOMPLETE);
  };
  var handleFailedActivateMapboxToken = function handleFailedActivateMapboxToken() {
    setMapboxTokenActive(true);
    onInputModeChange(ADDRESS_INPUT_MODES.MANUAL);
  };
  var handleLinkButtonClick = function handleLinkButtonClick() {
    var MANUAL = ADDRESS_INPUT_MODES.MANUAL,
      AUTOCOMPLETE = ADDRESS_INPUT_MODES.AUTOCOMPLETE;
    onInputModeChange(inputMode === MANUAL ? AUTOCOMPLETE : MANUAL);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, !disabled && isMapboxTokenActive && /*#__PURE__*/React.createElement(LinkButton, {
    style: linkButtonStyle,
    type: "button",
    onClick: handleLinkButtonClick
  }, linkText)), inputMode === ADDRESS_INPUT_MODES.AUTOCOMPLETE && /*#__PURE__*/React.createElement(AutocompleteAddress, {
    autocompletedAddress: autocompletedAddress,
    defaultCountry: defaultCountry,
    disabled: disabled || inputMode === ADDRESS_INPUT_MODES.MANUAL,
    isInModal: isInModal,
    mapBoxAccessToken: mapBoxAccessToken,
    onActivateMapboxToken: handleActivateMapboxToken,
    onAddressChange: onAddressChange,
    onFailedActivateMapboxToken: handleFailedActivateMapboxToken,
    onResult: onAutocompletedAddressResult,
    placeholder: autocompleteAddressPlaceholder || T.translate('ADDRESS_AUTOCOMPLETE_PLACEHOLDER'),
    resetAddressOnDelete: resetAddressOnDelete
  }), inputMode === ADDRESS_INPUT_MODES.MANUAL && /*#__PURE__*/React.createElement(React.Fragment, null, showManualCountry && /*#__PURE__*/React.createElement(SelectBox, {
    clearable: true,
    disabled: disabled,
    labelKey: "name",
    maxMenuHeight: 150,
    onChange: function onChange(value) {
      return onAddressChange({
        country: value ? value.isoCode : '',
        stateOrProvince: ''
      });
    },
    options: countries,
    placeholder: T.translate('ADDRESS_COUNTRY'),
    searchable: true,
    valueKey: "isoCode",
    value: countryValue
  }), /*#__PURE__*/React.createElement(TextInput, {
    disabled: disabled,
    onChange: function onChange(e) {
      return onAddressChange({
        addressLine1: e.target.value
      });
    },
    maxLength: "255",
    placeholder: T.translate('ADDRESS_LINE_1'),
    style: showManualCountry ? {
      marginTop: '15px'
    } : null,
    type: "text",
    value: addressLine1
  }), /*#__PURE__*/React.createElement(TextInput, {
    disabled: disabled,
    onChange: function onChange(e) {
      return onAddressChange({
        addressLine2: e.target.value
      });
    },
    maxLength: "255",
    placeholder: T.translate('ADDRESS_LINE_2'),
    style: {
      marginTop: '15px'
    },
    type: "text",
    value: addressLine2
  }), /*#__PURE__*/React.createElement(TextInput, {
    disabled: disabled,
    onChange: function onChange(e) {
      return onAddressChange({
        city: e.target.value
      });
    },
    maxLength: "255",
    placeholder: T.translate('ADDRESS_CITY'),
    style: {
      marginTop: '15px'
    },
    type: "text",
    value: city
  }), /*#__PURE__*/React.createElement("div", {
    style: flexStyle
  }, /*#__PURE__*/React.createElement("div", {
    style: spacedStyle
  }, /*#__PURE__*/React.createElement(SelectBox, {
    clearable: true,
    disabled: disabled || country === '',
    labelKey: "name",
    maxMenuHeight: 150,
    onChange: function onChange(value) {
      return onAddressChange({
        stateOrProvince: value ? value.isoCode : ''
      });
    },
    options: regions,
    placeholder: T.translate('ADDRESS_STATE_REGION'),
    searchable: true,
    valueKey: "isoCode",
    value: stateOrProvinceValue
  })), /*#__PURE__*/React.createElement(TextInput, {
    disabled: disabled,
    onChange: function onChange(e) {
      return onAddressChange({
        postalCode: e.target.value
      });
    },
    maxLength: "255",
    placeholder: T.translate('ADDRESS_ZIP_CODE'),
    style: spacedStyle,
    type: "text",
    value: postalCode
  }))));
};
AutocompleteOrManualAddress.propTypes = {
  address: PropTypes.shape({
    addressLine1: PropTypes.string.isRequired,
    addressLine2: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    postalCode: PropTypes.string.isRequired,
    stateOrProvince: PropTypes.string
  }).isRequired,
  autocompleteAddressPlaceholder: PropTypes.string,
  autocompletedAddress: PropTypes.string.isRequired,
  defaultCountry: PropTypes.string,
  disabled: PropTypes.bool,
  inputMode: PropTypes.string.isRequired,
  isInModal: PropTypes.bool,
  isMapboxTokenActive: PropTypes.bool.isRequired,
  mapBoxAccessToken: PropTypes.string.isRequired,
  onAddressChange: PropTypes.func.isRequired,
  onAutocompletedAddressResult: PropTypes.func.isRequired,
  onInputModeChange: PropTypes.func.isRequired,
  resetAddressOnDelete: PropTypes.bool.isRequired,
  setMapboxTokenActive: PropTypes.func.isRequired,
  showManualCountry: PropTypes.bool
};
AutocompleteOrManualAddress.defaultProps = {
  autocompleteAddressPlaceholder: undefined,
  defaultCountry: '',
  disabled: false,
  isInModal: false,
  showManualCountry: true
};
AutocompleteOrManualAddress.ADDRESS_INPUT_MODES = ADDRESS_INPUT_MODES;
export default AutocompleteOrManualAddress;
//# sourceMappingURL=component.js.map